let feedback_form = ( function ( $ ) {

	let $feedback_form;

	let _init = function () {
		$feedback_form = $( '#submit-feedback' );

		if ( $feedback_form.length ) {
			$feedback_form.on( 'saved field_hidden field_shown', function () {
				update_question_numbers();
			} )
		}
	};

	let update_question_numbers = function () {
		const $fields    = $feedback_form.find( '.field-wrap' );
		let field_number = 1;

		$fields.each( function () {
			if ( $( this ).css( 'display' ) === 'none' ) {
				return;
			}

			const $question_number = $( this ).children( 'label' ).find( '.question-number' );

			$question_number.text( field_number + '. ' );

			field_number++;
		} )
	};

	$( document ).ready( _init );

	return {};

} )( jQuery );

module.exports = feedback_form;